import * as React from 'react';
import { TextField as FormikTextField } from '@ane/ui-components/lib/components/FormikFormFields/TextField';
export class SpecialColumnsField extends React.Component {
    render() {
        const { textFieldProps = {}, fieldName, required = true } = this.props;
        const { description = 'Enter column name' } = textFieldProps;
        return (React.createElement(FormikTextField, { name: fieldName, innerTextFieldProps: {
                ...textFieldProps,
                description,
                required: required,
                ariaLabel: `${this.props.ariaLabel}`,
            } }));
    }
}

//# sourceMappingURL=SpecialColumnsField.js.map
